import { AlertDialog, AlertDialogContent } from "@jhool-io/fe-components";

function LoadPreviousSessionNotificationModal({
    showPrompt,
    setShowPrompt,
    handleLoadPreviousSession,
}: {
    showPrompt: boolean;
    setShowPrompt: (value: React.SetStateAction<boolean>) => void;
    handleLoadPreviousSession: () => void;
}) {
    return (
        <div>
            {showPrompt && (
                <AlertDialog open={showPrompt}>
                    <AlertDialogContent
                        title=" Load previous note"
                        description="Loading this note will overwrite your current
                content. Are you sure you want to proceed?"
                        cancelText="Cancel"
                        onCancelClick={() => setShowPrompt(false)}
                        saveText="Yes, Load Previous Note"
                        onSaveClick={handleLoadPreviousSession}
                    />
                </AlertDialog>
            )}
        </div>
    );
}
export default LoadPreviousSessionNotificationModal;
